var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolderFileWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 67,
    viewBox: "0 0 108 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.2499 0.347778H0.763672V57.1454C0.763672 62.1237 4.79941 66.1595 9.77775 66.1595H98.2354C103.214 66.1595 107.25 62.1237 107.25 57.1454V7.82166H53.0962C51.8384 7.82166 50.6378 7.29606 49.7846 6.37189L45.5615 1.79755C44.7083 0.873376 43.5077 0.347778 42.2499 0.347778Z",
    fill: "#F4FDFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderFileWhite);
export default __webpack_public_path__ + "static/media/folderFileWhite.b0d296ab40ee595ae546ee1dfde7a473.svg";
export { ForwardRef as ReactComponent };